import AgentOverview from '@/components/routes/agent/AgentOverview'
import fetchAgent from './utils/fetchAgent'
import AgentSettings from '@/components/routes/agent/agentSettings/AgentSettings'
import AgentEdit from '@/components/routes/agent/agentSettings/AgentEdit'
import AgentDisable from '@/components/routes/agent/agentSettings/AgentDisable'

const agentRoutes = [
  {
    name: 'agentOverview',
    path: '/agent/:agentId',
    component: AgentOverview
  },
  {
    name: 'agentSettings',
    path: '/agent/:agentId/settings',
    component: AgentSettings,
    redirect: {
      name: 'agentEdit'
    },
    children: [
      {
        name: 'agentEdit',
        path: 'agent-edit',
        component: AgentEdit
      },
      {
        name: 'agentDisable',
        path: 'agent-disable',
        component: AgentDisable
      }
    ]
  }
].map(route => {
  route.beforeEnter = fetchAgent
  return route
})

export default agentRoutes
